import { Component, OnInit, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import {NewPageService } from '../../templates/new-page/service/new-page.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { NewPageList } from '../../core/models/new-page-list';
import { SubListComponent } from '../sub-list/sub-list.component';
import { ListWithinList } from '../../core/models/list-within-list';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css'],
  providers:[NewPageService]
})
export class ListComponent implements OnInit {

  constructor(private _cfr: ComponentFactoryResolver,private newPageService:NewPageService,private confirmationService: ConfirmationService) { }
  @ViewChild('child', { read: ViewContainerRef }) child: ViewContainerRef;
  
  aboutUs :NewPageList;

  ngOnInit() {
    if(this.aboutUs.listWithinListList){
      this.aboutUs.listWithinListList.forEach(element=>{
        this.setChild(element);
      })
    }else{
      this.aboutUs.listWithinListList = new Array();
    }
  }

  eventList:boolean = true;

  _ref:any;
  
  confirmDelete() {
    this.confirmationService.confirm({
        message: 'Are you sure that you want to delete ?',
        accept: () => {
           this.remove();
        }
    });
  }
  
  remove(){
    this._ref.destroy();
    this.newPageService.removeItem(this.aboutUs);
  }  

  upItem(){
      this.newPageService.upItem(this.aboutUs);
  }

  downItem(){
    this.newPageService.downItem(this.aboutUs);
  }

  addChild(){
    let listWithinList = new ListWithinList();
    listWithinList.hasSubList = false;
    this.aboutUs.listWithinListList.push(listWithinList);
		var subList = this._cfr.resolveComponentFactory(SubListComponent);
    var expComponent = this.child.createComponent(subList);
    expComponent.instance._ref = expComponent;
    expComponent.instance.master = this.aboutUs;
    expComponent.instance.listWithinList = listWithinList;
  }
  setChild(listWithinList:ListWithinList){
		var subList = this._cfr.resolveComponentFactory(SubListComponent);
    var expComponent = this.child.createComponent(subList);
    expComponent.instance._ref = expComponent;
    expComponent.instance.master = this.aboutUs;
    expComponent.instance.listWithinList = listWithinList;
  }
}



// WEBPACK FOOTER //
// /app/src/app/layout/list/list.component.ts